import { Modal, Button } from "react-bootstrap"
export const ErrorModal = ({message, onHide}) => {

    return (
        <Modal show onHide={ onHide } centered>
            <Modal.Header>
                <Modal.Title className="d-flex gap-2 align-items-center text-danger">Error</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="font-weight-semi-bold mt-1 mb-2">{ message }</p>
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant='primary' onClick={ onHide }>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}